<button
  mat-stroked-button
  type="button"
  class="h-7 px-2 ml-auto text-xs font-medium min-w-0"
  [ngClass]="
    busy
      ? 'ai-action-busy text-project-4400 border-project-4500 bg-project-4600'
      : 'text-inherit border-project-2400/40 hover:text-project-300 hover:border-project-300 hover:bg-project-4600 disabled:opacity-50'
  "
  [disabled]="disabled"
  [title]="title"
  [attr.aria-label]="title"
  (click)="onClick($event)"
  (keydown.enter)="$event.stopPropagation()"
  (keydown.space)="$event.stopPropagation()"
>
  <span *ngIf="busy; else idleLabel" class="flex items-center min-w-0 gap-x-1">
    <mat-spinner class="shrink-0" [diameter]="12"></mat-spinner>
    <span class="truncate">{{ busyLabel }}</span>
  </span>
  <ng-template #idleLabel>
    <span class="flex items-center min-w-0 gap-x-1">
      <app-ai-icon class="text-inherit shrink-0"></app-ai-icon>
      <span class="truncate">{{ label }}</span>
    </span>
  </ng-template>
</button>
